import React, { useRef } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

// Single-row, swipeable card carousel with scroll-snap. Reused across listing sections.
export const SwipeRow = ({ children, testid = "swipe-row", itemClass = "w-[82%] sm:w-[48%] lg:w-[32%] xl:w-[24%]" }) => {
  const ref = useRef(null);
  const items = React.Children.toArray(children);

  const scrollBy = (dir) => {
    const el = ref.current;
    if (!el) return;
    el.scrollBy({ left: dir * el.clientWidth * 0.8, behavior: "smooth" });
  };

  return (
    <div className="relative">
      <div
        ref={ref}
        data-testid={testid}
        className="flex gap-6 md:gap-8 overflow-x-auto snap-x snap-mandatory cc-hide-scroll pb-2 -mx-6 px-6 md:mx-0 md:px-0"
      >
        {items.map((child, i) => (
          <div key={i} className={`snap-start shrink-0 ${itemClass}`}>
            {child}
          </div>
        ))}
      </div>

      {/* Desktop arrow controls */}
      <button
        type="button"
        aria-label="Scroll left"
        data-testid={`${testid}-prev`}
        onClick={() => scrollBy(-1)}
        className="hidden lg:flex items-center justify-center absolute -left-5 top-[38%] -translate-y-1/2 w-11 h-11 rounded-full bg-white shadow-lg border border-black/10 text-[#1a1a1a] hover:text-[#b4936a] hover:border-[#b4936a] transition-colors z-10"
      >
        <ChevronLeft size={20} strokeWidth={1.6} />
      </button>
      <button
        type="button"
        aria-label="Scroll right"
        data-testid={`${testid}-next`}
        onClick={() => scrollBy(1)}
        className="hidden lg:flex items-center justify-center absolute -right-5 top-[38%] -translate-y-1/2 w-11 h-11 rounded-full bg-white shadow-lg border border-black/10 text-[#1a1a1a] hover:text-[#b4936a] hover:border-[#b4936a] transition-colors z-10"
      >
        <ChevronRight size={20} strokeWidth={1.6} />
      </button>

      {/* swipe hint */}
      <p className="lg:hidden mt-4 text-[10px] tracking-luxe uppercase text-neutral-400 text-center">Swipe to explore &rarr;</p>
    </div>
  );
};

export default SwipeRow;
